// growthos/warchest-frontend/react-app/src/Components/v2/atoms/ActivityItems/ScenarioDuplicateActivity.tsx
import { FileCopy } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import React from "react";
import styled from "styled-components";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { ActivityEventEnum } from "@/pages/scenario-builder/types";
import { getUserName } from "@/pages/scenario-builder/utils/convertToActivity";

import { ActivityItemWrapper, IconContainer, IconWrapper } from "./shared/StyledComponents";
import { Activity } from "./types";

export const ScenarioDuplicateActivity: React.FC<{ activity: Activity }> = ({ activity }) => {
  if (activity.eventType !== ActivityEventEnum.ScenarioDuplicated) {
    return null;
  }

  const theme = useTheme();
  return (
    <ActivityItemWrapper>
      <IconContainer>
        <IconWrapper>
          <FileCopy sx={{ fontSize: "14px" }} />
        </IconWrapper>
      </IconContainer>
      <Box>
        <Typography variant="body2">
          Scenario <ScenarioName>{activity.data.sourceScenarioName}</ScenarioName> was duplicated
        </Typography>
        <Typography fontSize={12} sx={{ color: theme.palette.activityLog.user }}>
          {getUserName(activity.user)}
        </Typography>
      </Box>
    </ActivityItemWrapper>
  );
};

const ScenarioName = styled("span")`
  font-weight: 500;
`;
